export const capitalizeString = (str: string) => {
    // Check if the input string is empty or null
    if (!str) return '';
  
    // Capitalize the first letter and concatenate it with the rest of the string
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  };